import type { DiagramCommentFilters } from '../../domains/comments/models/Comment';

const baseKey = ['comments'] as const;

type CommentsKey = readonly unknown[];

function serializeFilters(filters?: DiagramCommentFilters): readonly (string | null)[] {
  if (!filters) return [] as const;
  const { state, shapeId } = filters;
  return [state ?? null, shapeId ?? null] as const;
}

export const commentsKeys = {
  all: baseKey,
  diagram(diagramId: string, filters?: DiagramCommentFilters): CommentsKey {
    return [...baseKey, 'diagram', diagramId, ...serializeFilters(filters)] as const;
  },
  thread(threadRootId: string): CommentsKey {
    return [...baseKey, 'thread', threadRootId] as const;
  },
} as const;

export type CommentsKeys = typeof commentsKeys;
